import apiService, { APIResponse } from "./axios";

import {
  formatDate,
  formatDatetime,
  formatDatetimeZ,
  formatTime,
} from "../../utils/formater";

import { RootState, store } from "../../store/store"; // Pfad zu deinem Store-File

export interface RentalPriceCalculation {
  total_price_main_rates: string;
  total_price_subrates: number;
  total_price_insurance: number;
  total_price_delivery_pickup: number;
  total_price_payment: number;
  total_price_voucher: number;
  main_rates: MainRate[];
  sub_rates: any[]; // Falls Daten kommen, hier Interface analog zu MainRate erstellen
  insurance_rates: any[];
  voucher_rates: any[];
  delivery_pickup_rates: any[];
  payment_rates: any[];
  end_positions: EndPosition[];
  total_price_monthly: number;
  total_price_onetime: number;
  total_tax_onetime: number;
  total_tax_monthly: number;
  total_price_delivery: number;
  total_price_pickup: number;
}

export interface MainRate {
  id: number;
  position: number;
  rate: string;
  description: string;
  description2: string | null;
  amount_real: number;
  amount: number;
  unit: string;
  unit_step2: string;
  single_price: number;
  single_price_step2: number;
  total_price: number;
  total_price_step2: number;
  long_price: number;
  long_price_step2: number;
  km_free: number;
  additional_km_price: number;
  total_long_price: string;
  total_long_price_step2: number;
  min_amount: number | null;
  max_amount: number | null;
  required: boolean | null;
  category: string | null;
  all_km_inclusive: boolean;
  is_temporal: boolean;
  main_rate: boolean;
  discount: number | null;
  contribution: number;
  contribution_step2: number;
  is_offer: boolean;
  tax: number;
  additional_km_long_price: number;
}

export interface EndPosition {
  id: number;
  position: number;
  rate: string;
  description: string;
  description2: string;
  amount_real: number | null;
  amount: number | null;
  unit: string | null;
  unit_step2: string | null;
  single_price: number;
  single_price_step2: number;
  total_price: number;
  total_price_step2: number;
  long_price: number;
  long_price_step2: number;
  km_free: number | null;
  additional_km_price: number;
  total_long_price: string;
  total_long_price_step2: number;
  min_amount: number | null;
  max_amount: number | null;
  required: boolean | null;
  category: string | null;
  all_km_inclusive: boolean;
  is_temporal: boolean | null;
  main_rate: boolean;
  discount: number | null;
  contribution: number | null;
  contribution_step2: number;
  is_offer: boolean;
  tax: number;
  additional_km_long_price: number | null;
}

class ORMCalculations {
  async calculate(state: any, datenow = false, cargroup = "") {
    try {
      const startStation = state.selectedStation;
      const endStation = state.selectedStationEnd || state.selectedStation;
      const startDate = state.startDate;
      const startTime = state.startTime;
      const endDate = state.endDate;
      const endTime = state.endTime;

      const payload = {
        startstation_id: startStation,
        planned_endstation_id: endStation,
        startdate:
          startDate && startTime && !datenow
            ? formatDatetime(`${startDate}T${startTime}`, false)
            : formatDatetime(Date.now(), false),
        planned_enddate:
          endDate && endTime && !datenow
            ? formatDatetime(`${endDate}T${endTime}`, false)
            : formatDatetime(Date.now(), false),
        planned_group_id: cargroup ? cargroup : state.setSelectedVehicle,
        distance: 0,
      };

      const response: APIResponse<any> = await apiService.post<any>(
        "api/rent/bookings/calculate",
        payload,
      );

      if (response.error) {
        console.error("Fehler von API:", response.message);
        return null;
      }

      return response as RentalPriceCalculation;
    } catch (error: any) {
      console.error("PRICECALC Error:", error);
      return null;
    }
  }
}

const ormCalculations = new ORMCalculations();
export default ormCalculations;
